import { InjectionToken } from '@angular/core';

export interface Token {
  access: string;
  refresh: string;
}

export const GOOGLE_ACCOUNTS_CLIENT_ID = new InjectionToken<string>(
  'Google accounts client ID.'
);

export const AUTH_ACCESS_TOKEN_KEY = new InjectionToken<string>(
  'Injection token for the authorization access token key.'
);
export const AUTH_REFRESH_TOKEN_KEY = new InjectionToken<string>(
  'Injection token for the authorization refresh token key.'
);
export const AUTH_GUARD_REDIRECTION_LINK = new InjectionToken<string>(
  'Injection token for the redirection page.'
);
